import { useTranslation } from 'react-i18next'
import { Button } from './ui/button'

/**
 * The "In: <scope>" chip with its "Search everywhere" button, for asset search
 * surfaces that use a plain `ApiSearchableSelect` instead of `AssetPicker`
 * (spec 2026-10-10-02). Renders nothing once widened or without a scope.
 */
export function AssetScopeChip({
    scopeLabel,
    widened,
    onWiden,
    testId,
}: {
    scopeLabel?: string
    widened: boolean
    onWiden: () => void
    testId: string
}) {
    const { t } = useTranslation('common')
    if (widened) return null
    return (
        <div className="flex items-center gap-2 text-xs text-muted-foreground" data-testid={`${testId}-scope`}>
            <span className="rounded-full border px-2 py-0.5" data-testid={`${testId}-scope-chip`}>
                {t('asset_picker.scope_in', { scope: scopeLabel ?? '' })}
            </span>
            <Button
                type="button"
                variant="link"
                size="sm"
                className="h-auto p-0 text-xs"
                onClick={onWiden}
                data-testid={`${testId}-search-everywhere`}
            >
                {t('asset_picker.search_everywhere')}
            </Button>
        </div>
    )
}
